// for common defines

import DualViewCanvas from '../canvas/DualViewCanvas';

// view orientation
enum ViewOrientation {
  Unknown,
  Top,
  Bottom,
  Left,
  Right,
  Front,
  Back,
}

// language option
enum LangOpt {
  Japanese = '日本語',
  Chinese = '简体中文',
  ChineseTW = '繁體中文',
  Turkish = 'Türkçe',
  Swedish = 'Svenska',
  Russian = 'русский',
  Portuguese = 'Português',
  Nederlands = 'Nederlands',
  Italian = 'Italiano',
  Spanish = 'Español',
  German = 'Deutsch',
  Danish = 'Dansk',
  French = 'Français',
  English = 'English',
}

// language locale, named style: change '-' to '_'
enum LangLocale {
  fr = 'fr',
  fr_FR = 'fr-FR',
  zh_CN = 'zh-CN',
  zh_TW = 'zh-TW',
  en = 'en',
  en_US = 'en-US',
  ja = 'ja-JP',
  tr = 'tr-TR',
  sv = 'sv-SE',
  ru = 'ru-RU',
  pt = 'pt-PT',
  nl = 'nl-NL',
  it = 'it-IT',
  es = 'es-ES',
  de = 'de-DE',
  da = 'da-DK',
}

const LanguagesMap = new Map<LangLocale, LangOpt>([
  [LangLocale.fr, LangOpt.French],
  [LangLocale.fr_FR, LangOpt.French],
  [LangLocale.zh_CN, LangOpt.Chinese],
  [LangLocale.zh_TW, LangOpt.ChineseTW],
  [LangLocale.en, LangOpt.English],
  [LangLocale.en_US, LangOpt.English],
  [LangLocale.ja, LangOpt.Japanese],
  [LangLocale.tr, LangOpt.Turkish],
  [LangLocale.sv, LangOpt.Swedish],
  [LangLocale.ru, LangOpt.Russian],
  [LangLocale.pt, LangOpt.Portuguese],
  [LangLocale.nl, LangOpt.Nederlands],
  [LangLocale.it, LangOpt.Italian],
  [LangLocale.es, LangOpt.Spanish],
  [LangLocale.de, LangOpt.German],
  [LangLocale.da, LangOpt.Danish],
]);

enum ToolID {
  Display,
  MarginLine,
  OrientationAdjustment,
  OcclusionMapping,
  Gallery,
}

enum AppStatus {
  Idle,
  Loading,
  Ready,
  Error,
}

// for dual view
const kDualViewNameFilters = ['Implant', 'Dual', 'Pre Scan', 'Edentulous', 'Extra Object'];

enum DualViewPanel {
  Left,
  Right,
}

const getDualViewPanal = (name: string) => {
  let panel = DualViewPanel.Left;

  kDualViewNameFilters.forEach((nameFilter) => {
    if (name.includes(nameFilter)) {
      panel = DualViewPanel.Right;
    }
  });

  return panel;
};

enum MeshName {
  Maxillary = 'Maxillary',
  MaxillaryAnatomy = 'Maxillary Anatomy',
  MaxillaryEdentulous = 'Maxillary Edentulous',
  MaxillaryPreScan = 'Maxillary Pre Scan',
  MaxillaryImplant = 'Maxillary Implant',
  Mandibular = 'Mandibular',
  MandibularAnatomy = 'Mandibular Anatomy',
  MandibularEdentulous = 'Mandibular Edentulous',
  MandibularPreScan = 'Mandibular Pre Scan',
  MandibularImplant = 'Mandibular Implant',
  BiteAverage = 'BiteAverage',
  ExtraObject = 'Extra Object',
  NormalBite = 'Normal Bite',
}

const SelectableMesh = [MeshName.Maxillary, MeshName.MaxillaryAnatomy, MeshName.Mandibular, MeshName.MandibularAnatomy];

enum ExportFormats {
  STL = 'stl',
  PLY = 'ply',
}

enum TextureFormats {
  JPG = 'jpg',
  PNG = 'png',
}

export {
  ViewOrientation,
  LangOpt,
  LangLocale,
  ToolID,
  kDualViewNameFilters,
  DualViewPanel,
  getDualViewPanal,
  MeshName,
  SelectableMesh,
  ExportFormats,
  TextureFormats,
  AppStatus,
  LanguagesMap,
};
